<!-- @format -->

<template>
  <div class="loader">
    <div class="loader-inner">
      <img
        class="ImgLoading"
        src="data:image/png;base64,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"
      />
      <svg
        style="margin-top: 61px; margin-right: 10px"
        width="120"
        height="30"
        viewBox="0 0 120 30"
        xmlns="http://www.w3.org/2000/svg"
        fill="#fff"
      >
        <circle cx="15" cy="15" r="15">
          <animate
            attributeName="r"
            from="15"
            to="15"
            begin="0s"
            dur="0.8s"
            values="15;9;15"
            calcMode="linear"
            repeatCount="indefinite"
          />
          <animate
            attributeName="fill-opacity"
            from="1"
            to="1"
            begin="0s"
            dur="0.8s"
            values="1;.5;1"
            calcMode="linear"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="60" cy="15" r="9" fill-opacity="0.3">
          <animate
            attributeName="r"
            from="9"
            to="9"
            begin="0s"
            dur="0.8s"
            values="9;15;9"
            calcMode="linear"
            repeatCount="indefinite"
          />
          <animate
            attributeName="fill-opacity"
            from="0.5"
            to="0.5"
            begin="0s"
            dur="0.8s"
            values=".5;1;.5"
            calcMode="linear"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="105" cy="15" r="15">
          <animate
            attributeName="r"
            from="15"
            to="15"
            begin="0s"
            dur="0.8s"
            values="15;9;15"
            calcMode="linear"
            repeatCount="indefinite"
          />
          <animate
            attributeName="fill-opacity"
            from="1"
            to="1"
            begin="0s"
            dur="0.8s"
            values="1;.5;1"
            calcMode="linear"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  </div>
</template>
